import React from 'react'
interface Props {
  className?: string
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StartupTag: React.FC<Props> = ({ className }) => {
  return (
    <span className="inline-block mr-[10px] bg-[#9329EF] text-white text-[12px] font-secondary font-bold h-5 w-[66px] text-center leading-5 tracking-[0.5px] rounded">
      Startup
    </span>
  )
}
